import {
  SchemaInstance,
  defineSchema,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import {
  baseTrackingSchema,
  exampleBaseTrackingSchemaInstance,
} from "./base-tracking";
import { returnTrackingSchema } from "./return-tracking";

const { storeCreditAmount, storeCreditActionUrl, storeCreditExpirationDate } =
  returnTrackingSchema.fields;

export const coverageCreditExpiringSchema = defineSchema({
  fields: {
    ...baseTrackingSchema.fields,
    storeCreditAmount: {
      ...storeCreditAmount,
      documentation: "The formatted store credit amount (e.g. $25.00).",
    },
    storeCreditActionUrl: {
      ...storeCreditActionUrl,
      documentation: "The URL where the customer can use the store credit.",
    },
    storeCreditExpirationDate: {
      ...storeCreditExpirationDate,
      documentation: "The date the store credit expires.",
    },
    discountCode: {
      dataType: "Maybe Text",
      documentation:
        "The Checkout+ reward discount code (only set for reward code triggers).",
      hideFromConditionStep: true,
    },
    discountValueDisplay: {
      dataType: "Maybe Text",
      documentation:
        "The reward code's value as shown to the shopper (e.g. $10 or 10%).",
      hideFromConditionStep: true,
    },
  },
});

export const exampleCoverageCreditExpiringSchemaInstance: SchemaInstance<
  typeof coverageCreditExpiringSchema
> = {
  ...exampleBaseTrackingSchemaInstance,
  storeCreditAmount: "$25.00",
  storeCreditActionUrl: "https://example.com",
  storeCreditExpirationDate: "2024-03-15",
  discountCode: "THANKS-AB12CD",
  discountValueDisplay: "$10",
};
